package medicalRecord.components


import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.message.message
import antd.modal.modal
import antd.radio.RadioChangeEvent
import antd.radio.radio
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.select
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.MedicalRecord
import com.jingfangpai.common.orm.mapping.Prescription
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordPatientSex
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordType
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import external.toJsObject
import kotlinext.js.Object
import kotlinext.js.jsObject
import kotlinx.browser.document
import kotlinx.html.js.onClickFunction
import kotlinx.html.visible
import react.*
import medicalRecord.containers.MedicalRecordEditPageContext
import org.w3c.dom.HTMLScriptElement
import react.dom.*
import react.router.dom.useHistory
import urlBase
import LearningRoute
import kotlin.reflect.KMutableProperty1
import kotlinext.js.js
external interface MedicalRecordEditProps : RProps {
  var id:String
}

data class MedicalRecordEditContextData(var placeHolderFunction: (param: String) -> Unit)

val MedicalRecordEdit = functionalComponent<MedicalRecordEditProps> { props ->

    val ctx = useContext(MedicalRecordEditPageContext)
    val history = useHistory()
    val (medicalRecord,setMedicalRecord) = useState(MedicalRecord())
    //val (editorScriptLoaded, setEditorScriptLoaded) = useState(false)
    val (editor,setEditor) = useState<CKEditor?>(null)
    val (editorContentLoaded,setEditorContentLoaded) = useState(false)
    val (showAddPrescriptionForm,setShowAddPrescriptionForm) = useState(false)
    val (editingPrescription,setEditingPrescription) = useState(Prescription())

    fun updateMedicalRecord(property: KMutableProperty1<MedicalRecord, *>, value:dynamic){
        console.log("medicalRecord",medicalRecord)
        val field = Object.assign(MedicalRecord(),medicalRecord)
        property.set(field,value)
        setMedicalRecord(field)
    }

    fun onContentChanged(event:dynamic,data:dynamic,editorInstance:CKEditor){
        setEditor(editorInstance)
    }

    fun onEditorInit(editor:CKEditor){
        console.log("onEditorInit",editor)
        setEditor(editor)

        editor.editing.view.change( {writer->
            writer.setStyle( "min-height", "400px", editor.editing.view.document.getRoot() );
        } );
        editor.model.document.on("change:data", {event,data->
            onContentChanged(event,data,editor)
        });
    }

    fun onSave(event: dynamic) {
        editor?.let {
            editor?.getData()?.let{ data ->
                medicalRecord.description = data
            }
        }
        if(medicalRecord.description.isNullOrBlank()){
            message.error("请填写医案描述")
            return;
        }
        message.loading("正在保存")
        ctx.save(medicalRecord,{ resp->
            if(resp.ok()){
                if(medicalRecord.id.isNullOrBlank()){ //新增
                    val newId = resp.data?.id ?: ""
                    history.push(LearningRoute.MedicalRecordEdit.link.url.replace(":id", newId))
                }else {
                    resp.data?.let { setMedicalRecord(it) }
                }
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    useEffect(medicalRecord) {
        if(editor != null && medicalRecord.description != null && (editor.getData() == null || editor.getData().isNullOrBlank()) && medicalRecord.description != editor.getData()){ //仅当编辑器内容为空时
            editor.setData(medicalRecord.description!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(editor){
        console.log("data",editor?.getData())
        if(editor != null && !editorContentLoaded && medicalRecord.description != null && editor.getData() != null && medicalRecord.description != editor.getData()){
            editor.setData(medicalRecord.description!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(props.id) {
        if("new"!=props.id){
            if(props.id.length == 32) {
                ctx.getById(props.id,{ resp->
                if(resp.ok() && resp.data !=null){
                    setMedicalRecord(resp.data!!)
                }else{
                    message.error("获取医案失败")
                }
            },{
                message.error("获取医案失败")
            })

            }
        }else{

        }
    }

    useEffectOnce {

        ClassicEditor.create(document.querySelector("#editor"), jsObject<EditorConf> {
            toolbar = jsObject <EditorToolbarConf> {
                items = arrayOf(
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "fontSize",
                    "fontColor",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "|",
                    "outdent",
                    "indent",
                    "|",
                    "imageUpload",
                    "blockQuote",
                    "insertTable",
                    "undo",
                    "redo",
                    "horizontalLine"
                )
            }
            language = "zh-cn"
            licenseKey = ""
        }
        )
            .then(::onEditorInit)
            .catch { error ->
                console.error(error);
            }


    }

    div("MedicalRecordEdit") {
        form{
            attrs{
                layout = "horizontal"
            }
            formItem {
                attrs{
                    label = "医案名称"
                }
                input {
                    attrs {
                        value = medicalRecord?.title?:""
                        placeholder = "请填写医案名称"
                        onChange = {event: dynamic ->
                            val entity = Object.assign(MedicalRecord(),medicalRecord)
                            entity.title = event.target.value as String
                            setMedicalRecord(entity)
                        }
                    }
                }
            }
            formItem {
                attrs{
                    label = "类别"
                }
                radioGroup {
                    attrs {
                        onChange = {event: RadioChangeEvent ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.type = MedicalRecordType.valueOf(event.target.value!! as String)
                            setMedicalRecord(_editing)
                        }
                        value = medicalRecord.type?.getLiteral()
                    }
                    MedicalRecordType.values().forEach { type->
                        radio {
                            attrs.value = type.getLiteral()
                            +type.getLiteral()
                        }
                    }
                }
            }

            formItem{
                attrs{
                    label = "书籍出处"
                }
                select<String, SelectComponent<String>> {
                    attrs {
                        showSearch = true
                        style = kotlinext.js.js { width = 200 }
                        value = medicalRecord.bookId?:""
                        onChange = { value: String, option: dynamic ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.bookId = value
                            _editing.source = option.children
                            setMedicalRecord(_editing)
                        }
                    }
                    option {
                        attrs.value = ""
                        +"无"
                    }
                    option {
                        attrs.value = "2968abf56bb811eca8bb525400cdb4bd"
                        +"胡希恕讲伤寒论"
                    }
                    option {
                        attrs.value = "34db4b3d6bb811eca8bb525400cdb4bd"
                        +"胡希恕讲金匮要略"
                    }
                    option {
                        attrs.value = "2968abf55bb811eca8bb525400cdb4bd"
                        +"经方实验录"
                    }
                    option {
                        attrs.value = "3f1fd7496bb811eca8bb525400cdb4bd"
                        +"一个老中医的经方奇缘"
                    }
                }
            }

            formItem {
                attrs{
                    label = "出处说明"
                }
                input {
                    attrs {
                        value = medicalRecord?.source?:""
                        placeholder = "请填写出处"
                        onChange = {event: dynamic ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.source = event.target.value as String
                            setMedicalRecord(_editing)
                        }
                    }
                }
            }
            formItem{
                attrs{
                    label = "医生"
                }
                select<String, SelectComponent<String>> {
                    attrs {
                        showSearch = true
                        style = kotlinext.js.js { width = 200 }
                        value = medicalRecord.doctorId?:""
                        onChange = { value: String, option: dynamic ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.doctorId = value
                            _editing.doctorName = option.children
                            setMedicalRecord(_editing)
                        }
                    }
                    option {
                        attrs.value = ""
                        +"其他"
                    }
                    option {
                        attrs.value = "3b8e81776bbb11eca8bb525400cdb4bd"
                        +"胡希恕"
                    }
                    option {
                        attrs.value = "44f0e9556bbb11eca8bb525400cdb4bd"
                        +"娄绍昆"
                    }
                    option {
                        attrs.value = "5dd7d0776bbb11eca8bb525400cdb4bd"
                        +"曹颖甫"
                    }
                    option {
                        attrs.value = "72aac4bb6bbb11eca8bb525400cdb4bd"
                        +"许叔微"
                    }
                    option {
                        attrs.value = "8a07a1e16bbb11eca8bb525400cdb4bd"
                        +"张丰"
                    }
                }
            }

            formItem {
                attrs{
                    label = "医生姓名"
                }
                input {
                    attrs {
                        value = medicalRecord?.doctorName?:""
                        placeholder = "请填写医生姓名"
                        onChange = {event: dynamic ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.doctorName = event.target.value as String
                            setMedicalRecord(_editing)
                        }
                    }
                }
            }

            formItem {
                attrs{
                    label = "患者姓名"
                }
                input {
                    attrs {
                        value = medicalRecord?.patientName?:""
                        placeholder = "请填写患者姓名"
                        onChange = {event: dynamic ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.patientName = event.target.value as String
                            setMedicalRecord(_editing)
                        }
                    }
                }
            }

            formItem {
                attrs{
                    label = "患者性别"
                }
                radioGroup {
                    attrs {
                        value = medicalRecord.patientSex?.getLiteral()
                        onChange = { event: dynamic ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.patientSex = MedicalRecordPatientSex.valueOf(event.target.value as String)
                            setMedicalRecord(_editing)
                        }
                        options = MedicalRecordPatientSex.values().map { CascadedOption(it.getLiteral(), it.getLiteral()) }
                            .toTypedArray().toJsObject()
                    }
                }
            }

            formItem {
                attrs{
                    label = "患者年龄"
                }
                input {
                    attrs {
                        type = "number"
                        value = medicalRecord.patientAge
                        placeholder = "请填写患者年龄"
                        onChange = {event: dynamic ->
                            val value = event.target.value as String
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.patientAge = if(value.isNullOrBlank()) null else value.toInt()
                            setMedicalRecord(_editing)
                        }
                    }
                }
            }

            formItem {
                attrs{
                    label = "医案详情"
                }
                div{
                    textarea{
                        attrs{
                            rows = "40"
                        }
                        attrs["id"] = "editor"
                    }
                }
            }

            formItem{
                attrs{
                    label = "关联体征、症状、疾病名"
                }
                +""
            }

            formItem{
                attrs{
                    label = "所用方剂"
                    extra = buildElement{
                        a{
                            attrs{
                                onClickFunction = {
                                    setShowAddPrescriptionForm(true)
                                    setEditingPrescription(Prescription())
                                }
                            }
                            +"添加方剂"
                        }
                    }
                }
                select<String, SelectComponent<String>> {
                    attrs {
                        showSearch = true
                        style = kotlinext.js.js { width = 200 }
                        value = medicalRecord.prescriptionId?:""
                        onChange = { value: String, option: dynamic ->
                            val _editing = Object.assign(MedicalRecord(), medicalRecord)
                            _editing.prescriptionId = value
                            setMedicalRecord(_editing)
                        }
                    }
                    option {
                        attrs.value = ""
                        +"自定义"
                    }
                }
            }

            formItem {
                attrs{
                    label = "处方内容"
                }
                textArea {
                    attrs {
                        value = medicalRecord.prescriptionContent ?:""
                        rows = 10
                        onChange = {event: dynamic ->
                            val entity = Object.assign(MedicalRecord(),medicalRecord)
                            entity.prescriptionContent = event.target.value as String
                            setMedicalRecord(entity)
                        }
                    }
                }
            }


            formItem {
                attrs {
                    label = ""
                }
                div {
                    attrs {
                        jsStyle = js {
                            textAlign = "right"
                        }
                    }
                    button {
                        attrs{
                            type = "primary"
                            onClick = ::onSave
                        }
                        +"保存"
                    }
                }
            }

        }
        modal{
            attrs{
                title = "添加方剂"
                visible = showAddPrescriptionForm
            }
            form{
                attrs{
                    layout = "horizontal"
                }
                formItem {
                    attrs{
                        label = "方剂名称"
                    }
                    input {
                        attrs {
                            value = editingPrescription?.name?:""
                            placeholder = "请填写方剂名称"
                            onChange = {event: dynamic ->
                                val _editing = Object.assign(MedicalRecord(), medicalRecord)
                                _editing.patientName = event.target.value as String
                                setMedicalRecord(_editing)
                            }
                        }
                    }
                }
            }
        }
    }
}
